import { render, staticRenderFns } from "./BCXMessengerChatMessagesPaged.vue?vue&type=template&id=c36892e2&scoped=true"
import script from "./BCXMessengerChatMessagesPaged.vue?vue&type=script&lang=ts&setup=true"
export * from "./BCXMessengerChatMessagesPaged.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BCXMessengerChatMessagesPaged.vue?vue&type=style&index=0&id=c36892e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36892e2",
  null
  
)

export default component.exports